module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"lines":"aucune ligne | 1 ligne | {total} lignes","firstLines":"{lines} premières lignes ({total} au total)"},"en":{"lines":"no line | 1 line | {count} lines","firstLines":"{lines} first lines ({total} total)"}}')
  delete Component.options._Ctor
}
